import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { EmailEventService, SenderType } from '@vendasta/email';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { catchError } from 'rxjs/operators';

interface ExportData {
  senderId: string;
  userId: string;
  normalizedUrl: string;
  attributeValue: string;
  attributeKey: string;
}
@Component({
  standalone: true,
  selector: 'email-download-link-activity-dialog',
  imports: [TranslateModule, MatDialogModule, MatButtonModule],
  providers: [],
  templateUrl: 'download-link-activity-dialog.html',
})
export class DownloadLinkActivityDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExportData,
    public dialogRef: MatDialogRef<DownloadLinkActivityDialogComponent>,
    private snackbarService: SnackbarService,
    private readonly emailEventService: EmailEventService,
  ) {}

  downloadData(): void {
    const senderType = this.data.senderId.startsWith('AG')
      ? SenderType.SENDER_TYPE_BUSINESS
      : SenderType.SENDER_TYPE_PARTNER;
    this.emailEventService
      .exportAttributeEventClickStats(
        {
          type: senderType,
          id: this.data.senderId,
        },
        {
          key: this.data.attributeKey,
          value: this.data.attributeValue,
        },
        this.data.normalizedUrl,
        this.data.userId,
      )
      .pipe(
        catchError(() => {
          this.snackbarService.openErrorSnack('CONTACT_TABLE.DOWNLOAD_DIALOG.ERROR');
          return 'error';
        }),
      )
      .subscribe((res) => {
        if (res !== 'error') {
          this.snackbarService.openSuccessSnack('CONTACT_TABLE.DOWNLOAD_DIALOG.SUCCESS');
        }
        this.dialogRef.close();
      });
  }
}
